<template>
  <div class="create">
    <el-row class="create-container">
      <el-col :span="18" style="height: 100%">
        <img class="logo-pic" src="../../../../common/img/loginBg.png">
        <div class="login_bgimg_title">{{$t('welcome_to_iceq')}}</div>
        <div class="login_bgimg_subtitle">{{$t('tenant_system')}}</div>
      </el-col>
      <el-col :span="6" class="login-form1">
        <div style="height:5%"></div>
        <div>
          <img style="width:auto;height:100px;" src="../../assets/img/logo-icon.png" />
        </div>
        <div style="height:5%"></div>
        <el-form :model="form" ref="createform" :rules="rules" style="width: 68%;margin:0 auto;">
          <!-- <i class="iconfont icon-logo"></i> -->
          <el-form-item style="text-align: left;">
            <template>
              <el-row>
                <el-col :span="24" style="text-align:center">
                  <div class="createaccount_tit">{{$t('create_account')}}</div>
                </el-col>
              </el-row>
            </template>
          </el-form-item>
          <div class="stepForm">
            <el-form-item alig>
              <div class="step">{{showTextArray[form.stepsActive]}}</div>
            </el-form-item>
          </div>
          <div class="userCreateForm" :style="'height:' + userCreateFormHeight + 'px;overflow-y: auto;overflow-x: hidden;'">
            <div class="step1" v-if="form.stepsActive === 0" style="margin-top: 30px;">
              <el-row>
                <el-col :span="24">
                  <el-radio v-model="form.but" border label="User" class="role_but">{{ $t('user') }}</el-radio>
                </el-col>
                <el-col :span="24">
                  <el-radio v-model="form.but" border label="Dealer" class="role_but">{{ $t('reseller') }}</el-radio>
                </el-col>
              </el-row>
            </div>
            <div class="step2" v-if="form.stepsActive === 1" :key="1">
              <el-row :gutter="3">
                <el-col :span="24">
                  <el-form-item>
                    <label class="step-lable" slot="label">{{ $t('title') }}</label>
                    <el-select v-model="form.title" class="step-input" clearable="">
                      <el-option v-for="item in titleOptions" :key="item.code" :label="item.name" :value="item.code" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="3">
                <el-col :span="24">
                  <el-form-item prop="firstName">
                    <label class="step-lable" slot="label">{{ $t('first_name') }}</label>
                    <el-input type="text" class="common-input" v-model="form.firstName" autocomplete="off" maxlength="100"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item prop="lastName">
                    <label class="step-lable" slot="label">{{ $t('last_name') }}</label>
                    <el-input type="text" class="common-input" v-model="form.lastName" autocomplete="off" maxlength="100"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="3">
                <el-col :span="24">
                  <el-form-item prop="cellphone">
                    <label class="step-lable" slot="label">{{ $t('cellphone') }}</label>
                    <el-input type="text" class="common-input" v-model="form.cellphone" autocomplete="off" maxlength="20"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item prop="email">
                    <label class="step-lable" slot="label">{{ $t('email') }}</label>
                    <el-input type="text" class="common-input" v-model="form.email" @blur="emailBlur" autocomplete="off"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <!-- <div class="step3" v-if="form.stepsActive === 2" :key="2">
            </div> -->
            <div class="step4" v-if="form.stepsActive === 2" :key="2">
              <el-form-item prop="company">
                <label class="step-lable" slot="label">{{ $t('company') }}</label>
                <el-input type="text" class="common-input" v-model="form.company" autocomplete="off" maxlength="200"></el-input>
              </el-form-item>
              <el-form-item prop="address">
                <label class="step-lable" slot="label">{{ $t('address') }}</label>
                <el-input type="text" class="common-input" v-model="form.address" autocomplete="off" maxlength="200"></el-input>
              </el-form-item>
              <el-form-item prop="address2">
                <label class="step-lable" slot="label">{{ $t('address2') }}</label>
                <el-input type="text" class="common-input" v-model="form.address2" autocomplete="off" maxlength="200"></el-input>
              </el-form-item>
              <el-row :gutter="5">
                <el-col :span="12">
                  <el-form-item prop="city">
                    <label class="step-lable" slot="label">{{ $t('city') }}</label>
                    <el-input type="text" class="step-input" v-model="form.city" autocomplete="off" maxlength="100"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="zip">
                    <label class="step-lable" slot="label">{{ $t('zip') }}</label>
                    <el-input type="text" class="step-input" v-model="form.zip" autocomplete="off" maxlength="100"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item prop="state">
                    <label class="step-lable" slot="label">{{ $t('state') }}</label>
                    <el-input type="text" class="step-input" v-model="form.state" autocomplete="off" maxlength="100"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item prop="country">
                    <label class="step-lable" slot="label">{{ $t('country') }}</label>
                    <el-select v-model="form.country" filterable class="step-input">
                      <el-option v-for="item in countryOptions" :key="item.code" :label="item.name" :value="item.code" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div v-if="form.stepsActive === 3" :key="3">
              <el-form-item prop="password">
                <label class="step-lable" slot="label">{{ $t('password') }}</label>
                <el-input show-password class="common-input" v-model="form.password" autocomplete="off" @change="checkStrong" maxlength="100"></el-input>
              </el-form-item>
              <el-form-item prop="repeatPassword">
                <label class="step-lable" slot="label">{{ $t('repeat_password') }}</label>
                <el-input show-password class="common-input" v-model="form.repeatPassword" autocomplete="off" maxlength="100"></el-input>
              </el-form-item>
              <el-form-item>
                <el-form-item>
                  <label class="step-lable" slot="label">{{ $t('password_strength') }}</label>
                  <div class="clearfix" style="display: inline-block; width: 100%">
                    <el-form-item>
                      <el-row :gutter="3">
                        <el-col :span="8">
                          <div id="one" style="float:left; width:100%; background-color:white">
                            <p v-show="modes = 2" style="line-height:20px" v-text="$t('strength_low')"></p>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div id="two" style="float:left;width:100%; background-color:white">
                            <p v-show="modes = 3" style="line-height:20px" v-text="$t('strength_mid')"></p>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div id="three" style="float:left;width:100%; background-color:white">
                            <p v-show="modes = 4" style="line-height:20px" v-text="$t('strength_high')"></p>
                          </div>
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </div>
                </el-form-item>
              </el-form-item>
            </div>
            <div class="step6" v-if="form.stepsActive === 4" :key="4" style="margin-top: 5%;">
              <div class="create_check1">
                <el-checkbox v-model="form.privacyChecked">
                  <span>{{$t('privacy') + ' '}}
                    <a href="privacy.html" target="_blank" style="border-bottom:1px solid #606266;text-decoration: none;color: #606266;">{{$t('privacy_notice')}}</a>
                    {{' ' + $t('and') + ' '}}
                    <a href="terms.html" target="_blank" style="border-bottom:1px solid #606266; text-decoration: none; color: #606266">{{$t('terms_of_use')}}</a>
                  </span>
                </el-checkbox>
              </div>
              <div class="create_check2" style="margin-top: 10px">
                <el-checkbox v-model="form.sendupdateChecked">{{$t('send_update')}}</el-checkbox>
              </div>
              <div class="pic" @click="changeCodeImg()">
                <i class="el-icon-refresh"></i>
                <img :src="codeImg">
                <i class="el-icon-refresh click-icon"></i>
              </div>
              <div style="width:100%;">
                <span style="width:94%;display:block;word-wrap:break-word;overflow:hidden;">{{ $t('enter_character') }}</span>
              </div>
              <el-form-item>
                <el-input type="text" class="common-input" v-model="form.captcha" autocomplete="off" maxlength="4"></el-input>
              </el-form-item>
            </div>
          </div>
          <el-form-item v-if="form.stepsActive === 4">
            <el-button type="primary" round class="common-input" @click="register">{{ $t('create') }}</el-button>
          </el-form-item>
          <el-form-item v-if="form.stepsActive === 0 || form.stepsActive === 1 || form.stepsActive === 2 || form.stepsActive === 3">
            <el-button class="common-input" style="margin-top: 10px" type="default" round @click="next">{{$t('next')}}</el-button>
          </el-form-item>
          <el-form-item v-if="form.stepsActive === 1 || form.stepsActive === 2 || form.stepsActive === 3 || form.stepsActive === 4">
            <el-button class="common-input" type="default" round @click="previous">{{$t('previous')}}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="default" round class="common-input" @click="handleSignInClick">{{ $t('signIn') }}</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import authInfoMgmt from '../../auth-info-mgmt-inst';
import i18nMgmt from '../../locale/i18n-mgmt-inst';
import userApi from '../../apis/user';

export default {
  name: 'createaccount',
  components: {},
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('input_password')));
      } else {
        if (!this.$formValidation.passwordreg.test(value)) {
          callback(new Error(this.$t('password_error')));
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('input_password_again')));
      } else if (value !== this.form.password) {
        callback(new Error(this.$t('password_error_two')));
      } else {
        callback();
      }
    };
    return {
      language: '',
      languageOptions: [],
      codeImg: '',
      userCreateFormHeight: 0,
      form: {
        email: '',
        password: '',
        repeatPassword: '',
        firstName: '',
        lastName: '',
        sex: '',
        title: '',
        country: '',
        zip: '',
        cellphone: '',
        address: '',
        address2: '',
        city: '',
        state: '',
        company: '',
        but: 'User',
        captcha: '',
        captchaToken: '',
        privacyChecked: false,
        sendupdateChecked: true,
        stepsActive: 0
      },
      titleOptions: [
        {
          name: 'Mr',
          code: 0
        },
        {
          name: 'Mrs',
          code: 1
        },
        {
          name: 'Ms',
          code: 2
        },
        {
          name: 'Miss',
          code: 3
        },
        {
          name: 'Dr',
          code: 4
        },
        {
          name: 'Prof',
          code: 5
        },
        {
          name: 'other',
          code: 6
        }
      ],
      countryOptions: [],
      sexOptions: [
        {
          name: this.$t('male'),
          code: 10
        },
        {
          name: this.$t('female'),
          code: 20
        },
        {
          name: this.$t('other'),
          code: 30
        }
      ],
      modes: 0,
      emailError: false,
      rules: {
        firstName: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],

        lastName: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],

        sex: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],

        email: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Email format error',
            trigger: 'blur'
          }
        ],

        cellphone: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],

        // zip: [
        //   {
        //     required: true,
        //     message: this.$t('required'),
        //     trigger: 'blur'
        //   }
        // ],

        country: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],

        company: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],

        address: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],

        password: [{ validator: validatePass, trigger: 'blur' }],
        repeatPassword: [{ validator: validatePass2, trigger: 'blur' }]
      },
      showTextArray: [
        this.$t('role'),
        this.$t('personal'),
        // this.$t('contact'),
        this.$t('commercial'),
        this.$t('account'),
        this.$t('article')
      ]
    };
  },

  created() {
    const logoHeight = 160;
    const titeleHeight = 80;
    const buttonHeight = 90;
    this.userCreateFormHeight =
      window.innerHeight * 0.95 -
      logoHeight -
      titeleHeight -
      buttonHeight -
      120;
    this.changeCodeImg();
  },

  mounted() {
    this.languageOptions = i18nMgmt.getLangList();
    this.language = i18nMgmt.getCurLang();
    userApi.getCountry().then((response) => {
      this.countryOptions = response.list;
    });
  },
  methods: {
    onLangChanged() {
      const loading = this.$loading();
      i18nMgmt.setLang(this.$i18n, this.language).then(() => {
        loading.close();
      });
    },
    handleSignInClick() {
      this.$router.push({
        name: 'Login'
      });
    },
    changeCodeImg() {
      authInfoMgmt.DataUrlPic({}).then((data) => {
        this.form.captchaToken = data.token;
        this.codeImg = data.dataUrl;
      });
    },
    register() {
      if (!this.form.privacyChecked) {
        this.$message({
          message: this.$t('user_check'),
          type: 'warning',
          duration: 5000
        });
        return;
      }
      if (this.form.captcha === '') {
        this.$message({
          message: this.$t('not_null'),
          type: 'warning',
          duration: 5000
        });
      } else {
        if (this.form.but === 'User') {
          authInfoMgmt
            .GetCustomer({
              ...this.form
            })
            .then((CustomerData) => {
              if (CustomerData.succeeded) {
                this.$message({
                  message: this.$t('customer_success'),
                  type: 'success',
                  duration: 5000
                });
                this.$router.push({
                  name: 'Login'
                });
              } else {
                const errormsgArray = [
                  this.$t('ver_code_error'),
                  this.$t('ver_code_exd'),
                  this.$t('user_password_error'),
                  this.$t('user_password_error')
                ];
                this.$message({
                  message: errormsgArray[CustomerData.reason - 1],
                  type: 'warning',
                  duration: 5000
                });
              }
            });
        } else if (this.form.but === 'Dealer') {
          authInfoMgmt
            .GetDealer({
              ...this.form
            })
            .then((DealerData) => {
              if (DealerData.succeeded) {
                this.$message({
                  message: this.$t('dealer_success'),
                  type: 'success',
                  duration: 5000
                });
                this.$router.push({
                  name: 'Login'
                });
              } else if (DealerData.reason === 1) {
                this.$message({
                  message: this.$t('ver_code_error'),
                  type: 'warning',
                  duration: 5000
                });
              } else if (DealerData.reason === 2) {
                this.$message({
                  message: this.$t('ver_code_exd'),
                  type: 'warning',
                  duration: 5000
                });
              } else if (DealerData.reason === 3) {
                this.$message({
                  message: this.$t('user_password_error'),
                  type: 'error',
                  duration: 5000
                });
              } else if (DealerData.reason === 4) {
                this.$message({
                  message: this.$t('user_password_error'),
                  type: 'error',
                  duration: 5000
                });
              }
            });
        }
      }
    },
    emailBlur() {
      if (this.form.email === '') {
      } else {
        authInfoMgmt
          .GetUserEmail({
            email: this.form.email
          })
          .then((data) => {
            if (data.succeeded) {
              this.emailError = false;
            } else if (data.reason) {
              this.emailError = true;
            }
          });
      }
    },

    passwordBlur() {
      const reg = this.$formValidation.passwordreg;
      if (!reg.test(this.form.password)) {
        this.$message({
          message: this.$t('password_error'),
          type: 'warning',
          duration: 5000
        });
      }
    },
    cancelClick() {
      this.$router.back();
    },

    next() {
      this.$refs.createform.validate((valid) => {
        if (valid) {
          if (this.emailError) {
            this.$message({
              message: this.$t('registered'),
              type: 'error',
              duration: 5000
            });
            return false;
          } else {
            if (this.form.stepsActive++ > 4) this.form.stepsActive = 0;
          }
        } else {
          return false;
        }
      });
    },

    previous() {
      if (this.form.stepsActive >= 1 || this.form.stepsActive <= 6) {
        this.form.stepsActive--;
      }
    },

    prev() {
      --this.form.stepsActive;
      if (this.form.stepsActive < 0) this.form.stepsActive = 0;
    },

    checkStrong(sValue) {
      this.modes = 0;
      if (/\d/.test(sValue)) this.modes++;
      if (/[a-z]/.test(sValue)) this.modes++;
      if (/[A-Z]/.test(sValue)) this.modes++;
      if (/\W/.test(sValue)) this.modes++;
      if (this.modes === 2) {
        document.getElementById('one').style.background = '#fd825f';
      } else {
        document.getElementById('one').style.background = '#eee';
      }
      if (this.modes === 3) {
        document.getElementById('one').style.background = '#53d8d8';
        document.getElementById('two').style.background = '#53d8d8';
      } else {
        document.getElementById('two').style.background = '#eee';
      }
      if (this.modes === 4) {
        document.getElementById('one').style.background = '#51c83d';
        document.getElementById('two').style.background = '#51c83d';
        document.getElementById('three').style.background = '#51c83d';
      } else {
        document.getElementById('three').style.background = '#eee';
      }
    }
  }
};
</script>

<style lang="scss">
.login-form1 {
  background: #f4f4f4;
  height: 100%;
  position: relative;
  width: 25%;
  float: left;
  text-align: center;
}
.create {
  width: 100vw;
  height: 100vh;

  &-container {
    height: 100%;
    width: 100%;
  }

  .common-input {
    width: 100%;
    height: 40px;
  }

  .step-lable {
    min-width: 100px;
    font-size: 16px;
    padding-left: 15px;
    font-weight: bold;
    color: #292929;
    height: 28px;
  }

  .step-input {
    width: 100%;
    height: 40px;
    margin-right: 10px;
  }

  .el-form-item {
    margin-bottom: 10px;
  }
}

.role_but {
  min-width: 100px;
  width: 100%;
  margin-bottom: 10px;
}

.login_bgimg {
  width: 722px;
  height: 568px;
  background: url('../../../../common/img/loginBg.png') no-repeat;
  margin: auto;
}

// .login_logo {
//   color: #292929;
//   font-size: 96px;
//   font-weight: bold;
//   margin-bottom: 43px;
// }

.logingo {
  width: 100%;
  height: 100%;
  background: #f4f4f4;
}

.createaccount_tit {
  font-size: 34px;
  color: #292929;
  font-weight: bold;
}

.login_bgimg_title {
  color: #203556;
  font-weight: bold;
  font-size: 55px;
  line-height: 66px;
  letter-spacing: 1.44px;
}

.bg-purple {
  color: #333333;
  font-weight: bold;
  font-size: 16px;
}

.bg-purple-title {
  text-align: left;
  margin-left: 135px;
}

.forget_title {
  color: #2a2a2a;
  font-size: 12px;
  margin-top: 20px;
  cursor: pointer;
}

// .or_title {
//   color: #2a2a2a;
//   font-weight: bold;
//   font-size: 14px;
//   margin: 20px auto;
// }

.margin {
  margin-top: 60px;
  margin-bottom: 30px;
}

// .or-line {
//   display: inline-block;
//   width: 110px;
//   height: 1px;
//   background: #c4c4c4;
//   vertical-align: middle;
// }

.create_check1,
.create_check2 {
  text-align: left;
  .el-checkbox__label {
    width: 90%;
    word-break: normal;
  }
}

.userCreateForm .el-input__inner {
  height: 28px;
}
.pic {
  margin: 2% auto 0px;
  position: relative;
  cursor:pointer;
}

.pic .el-icon-refresh{
  font-size: 20px;
  position:absolute;
  top: 3px;
  right: 5px;
  color: #2c3e50;
}

.pic img {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.login_bgimg_subtitle {
  font-size: 55px;
}

.stepForm {
  // text-align:center;
  font-size: 26px;

  .step {
    font-size: 24px;
  }

  .el-step__main {
    position: absolute;
    left: 0px;
  }

  .el-step__line {
    background-color: #3266ff;
  }

  .el-step__head.is-process {
    .el-step__icon.is-text {
      color: #3266ff;
      border-color: #3266ff;
    }
  }

  .el-step__title {
    font-size: 12px;
    font-weight: 400;
  }

  .el-step__title.is-process {
    color: #3266ff;
    font-size: 12px;
    font-weight: 400;
    white-space: nowrap !important;
  }

  .el-step__head.is-wait {
    color: #000000;
    border-color: #000000;
    // .el-step__line {
    //   left: 80px;
    // }
    .el-step__line {
      background-color: #000000;
    }
  }

  .el-step__title.is-wait {
    color: #000000;
    font-size: 12px;
    font-weight: 400;
    white-space: nowrap !important;
  }

  .el-step__head.is-success {
    .el-step__line {
      background-color: #67c23a;
    }
  }

  .el-step__title.is-success {
    font-size: 12px;
    font-weight: 400;
    white-space: nowrap !important;
  }
}

.lin-38 {
  .el-step__title.is-wait {
    line-height: 38px;
  }
}

.el-step.is-horizontal .el-step__line {
  left: 77px;
  right: 5px;
}

.process {
  .el-step__head {
    .el-step__line {
      left: 55px;
      right: 5px;
    }
  }
}

.click-icon {
  position: absolute;
  right: 5px;
  top: 5px;
  color: #fff;
  cursor: pointer;
  font-size: 18px;
}

.level {
  background: #f4f4f4;
  // float: left;
  border-left: 0px solid;
  border-right: 0px solid;
  margin-top: 10px;
  margin-left: 5px;
  margin-right: 3px;
  width: 100%;
  height: 20px;
}

.low_level {
  background: #fd825f;
}

.step2 {
  .el-form-item__label {
    line-height: 20px;
  }
}

.middle_level {
  background: #53d8d8;
}

.high_level {
  background: #51c83d;
}
</style>